import React from 'react'

function KeepInTouch() {
  return (
    <section class="wrapper custom-wrapper footer-contact-wrapper">
        <div class="container contact-container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="block-title">Keep in touch</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 col-sm-6 text-center cercle-block">
                        <a href="javascript:void(0);">
                            <span class="icon hvr-pulse"><i class="fa fa-phone"></i></span>
                        <h4>Call Us</h4>
                        <p>+91 98360 44395</p>
                    </a>
                    </div>
                <div class="col-md-3 col-sm-6 text-center cercle-block">
                        <a href="javascript:void(0);">
                            <span class="icon hvr-pulse"><i class="fa fa-envelope"></i></span>
                        <h4>Email us</h4>
                        <p>info@technowebsol.com</p>
                    </a>
                    </div>
                <div class="col-md-3 col-sm-6 text-center cercle-block">
                        <a href="javascript:void(0);">
                            <span class="icon hvr-pulse"><i class="fa fa-skype"></i></span>
                        <h4>Chat with us</h4>
                        <p>Techno Web Solutions</p>
                    </a>
                    </div>
                <div class="col-md-3 col-sm-6 text-center cercle-block">
                        <a href="javascript:void(0);">
                            <span class="icon hvr-pulse"><i class="fa fa-lightbulb-o"></i></span>
                        <h4>Share ideas with us</h4>
                        <p>sales@technowebsol.com</p>
                    </a>
                    </div>
            </div>
        </div>
    </section>
  )
}

export default KeepInTouch